var map = {
	"./ended/pedestrian.svg": 550,
	"./interval/pedestrian.svg": 551,
	"./offline/pedestrian.svg": 368,
	"./online/pedestrian.svg": 369,
	"./paused/pedestrian.svg": 552
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1043;